import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=0f089167&"
import script from "./QuestionHeader.vue?vue&type=script&lang=ts&"
export * from "./QuestionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports